import React, { useState } from 'react';
import ProductCard from './ProductCard';
import ProductModal from './ProductModal';
import { products, categories } from '../data/products';

const Products = () => {
    const [activeCategory, setActiveCategory] = useState('all');
    const [selectedProduct, setSelectedProduct] = useState(null);

    const filteredProducts = activeCategory === 'all' ? products : products.filter((p) => p.category === activeCategory);

    return (
        <section id="productos" className="py-20 md:py-28 relative overflow-hidden">
            <div className="absolute top-0 left-0 w-72 h-72 bg-dulce-pink-100 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl opacity-40" />
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-dulce-cream-100 rounded-full translate-x-1/2 translate-y-1/2 blur-3xl opacity-50" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
                <div className="text-center mb-16 animate-on-scroll">
                    <span className="inline-block text-dulce-pink-500 text-sm font-semibold tracking-widest uppercase mb-3">
                        ✨ Nuestras Delicias ✨
                    </span>
                    <h2 className="section-title text-gray-800">
                        Postres <span className="text-gradient-pink">Irresistibles</span>
                    </h2>
                    <p className="section-subtitle">
                        Cada postre es una obra de arte hecha con amor 💕
                    </p>
                    <div className="w-24 h-1 bg-gradient-to-r from-dulce-pink-400 to-dulce-rose-400 mx-auto rounded-full" />
                </div>

                <div className="flex flex-wrap justify-center gap-3 mb-12">
                    {categories.map((category) => (
                        <button key={category.id} onClick={() => setActiveCategory(category.id)}
                            className={`px-5 py-2.5 rounded-full font-medium text-sm transition-all duration-300 transform hover:scale-105 ${activeCategory === category.id
                                ? 'bg-gradient-to-r from-dulce-pink-500 to-dulce-rose-500 text-white shadow-lg'
                                : 'bg-white text-gray-600 hover:bg-dulce-pink-50 hover:text-dulce-pink-600 shadow-md border border-gray-100'
                                }`}>
                            <span className="mr-1.5">{category.icon}</span>
                            {category.name}
                        </button>
                    ))}
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 md:gap-8">
                    {filteredProducts.map((product) => (
                        <ProductCard key={product.id} product={product} onViewDetails={setSelectedProduct} />
                    ))}
                </div>
            </div>

            {selectedProduct && <ProductModal product={selectedProduct} onClose={() => setSelectedProduct(null)} />}
        </section>
    );
};

export default Products;